import {
  INFLUENCER_INTERESTED_SUCCESS,
  INFLUENCER_INTERESTED_FAILURE,
  COMPANY_INTERESTED_SUCCESS,
  COMPANY_INTERESTED_FAILURE,
  CLOSE_NOTIFICATION,
  CAMPAIGN_SAVE_SUCCESS,
  CAMPAIGN_SAVE_FAILURE,
  INFLUENCER_MATCH_SUCCESS,
  COMPANY_MATCH_SUCCESS,
  MATCH_FAILURE,
  MATCH_REJECT_FAILURE,
  MATCH_REJECT_SUCCESS,
  ARCHIVE_SUCCESS,
  ARCHIVE_FAILURE,
  DEAL_PROPOSAL_SUCCESS,
  DEAL_PROPOSAL_FAILURE,
  UNMATCH_SUCCESS,
  UNMATCH_FAILURE,
  REJECT_PROPOSAL_SUCCESS,
  REJECT_PROPOSAL_FAILURE,
  REVISION_REQUEST_SUCCESS,
  REVISION_REQUEST_FAILURE,
  ACCEPT_DEAL_SUCCESS,
  ACCEPT_DEAL_FAILURE,
  ESCROW_PROCESS_SUCCESS,
  ESCROW_PROCESS_FAILURE,
  RELEASE_ESCROW_PROCESS_SUCCESS,
  RELEASE_ESCROW_PROCESS_FAILURE,
  SUBMIT_CONTENT_SUCCESS,
  SUBMIT_CONTENT_FAILURE,
  PRODUCT_ADD_SUCCESS,
  PRODUCT_ADD_FAILURE,
  OPEN_DISPUTE_SUCCESS,
  OPEN_DISPUTE_FAILURE,
  RESET_PASSWORD_EMAIL_SEND_SUCCESS,
  RESET_PASSWORD_EMAIL_SEND_FAILURE,
  USER_PAYPAL_INFO_SUCCESS,
  USER_PAYPAL_INFO_FAILURE,
  CONTENT_COMPLETE_SUCCESS,
  CONTENT_COMPLETE_FAILURE,
  UPDATE_COMPANY_BALANCE_SUCCESS,
  UPDATE_COMPANY_BALANCE_FAILURE,
  PAY_WITH_BALANCE_FAILURE,
  NO_ACTIVE_CAMPAIGNS
} from '../constants';

const initState = {
  open: false,
  message: '',
  variant: ''
};

const notificationsReducer = (state = initState, action) => {
  switch (action.type) {
    case CLOSE_NOTIFICATION:
      return {
        ...initState
      };
    case INFLUENCER_INTERESTED_SUCCESS:
      return {
        message: 'Successfully Sent To Company!',
        open: true,
        variant: 'success'
      };
    case INFLUENCER_INTERESTED_FAILURE:
      return {
        message: 'Proposal Already Sent!',
        open: true,
        variant: 'success'
      };
    case COMPANY_INTERESTED_SUCCESS:
      return {
        message: 'Successfully Sent To Influencer!',
        open: true,
        variant: 'success'
      };
    case COMPANY_INTERESTED_FAILURE:
      return {
        message: 'Proposal Already Sent!',
        open: true,
        variant: 'success'
      };
    case CAMPAIGN_SAVE_SUCCESS:
      return {
        message: 'Successfully Created Campaign!',
        open: true,
        variant: 'success'
      };
    case CAMPAIGN_SAVE_FAILURE:
      return {
        message: 'Error Creating Campaign',
        open: true,
        variant: 'error'
      };
    case INFLUENCER_MATCH_SUCCESS:
      return {
        message: 'Match Successful!',
        open: true,
        variant: 'success'
      };
    case COMPANY_MATCH_SUCCESS:
      return {
        message: `Match Successful! <a href="/messages" class="linkClass">Message</a> or <a href="/deals" class="linkClass">Propose Deal</a> to your new match.`,
        open: true,
        variant: 'success'
      };
    case MATCH_FAILURE:
      return {
        message: 'Error Completing Matching',
        open: true,
        variant: 'error'
      };
    case MATCH_REJECT_SUCCESS:
      return {
        message: 'Successfully Rejected Match',
        open: true,
        variant: 'success'
      };
    case MATCH_REJECT_FAILURE:
      return {
        message: 'Failed To Reject Match',
        open: true,
        variant: 'error'
      };
    case ARCHIVE_SUCCESS:
      return {
        message: 'Archived Deal',
        open: true,
        variant: 'success'
      };
    case ARCHIVE_FAILURE:
      return {
        message: 'Failed Archiving Deal',
        open: true,
        variant: 'error'
      };
    case DEAL_PROPOSAL_SUCCESS:
      return {
        message: 'Proposal Sent!',
        open: true,
        variant: 'success'
      };
    case DEAL_PROPOSAL_FAILURE:
      return {
        message: 'Failed To Send Proposal',
        open: true,
        variant: 'error'
      };
    case UNMATCH_SUCCESS:
      return {
        message: 'Successfully Unmatched',
        open: true,
        variant: 'success'
      };
    case UNMATCH_FAILURE:
      return {
        message: 'Failed To Unmatch',
        open: true,
        variant: 'error'
      };
    case REJECT_PROPOSAL_SUCCESS:
      return {
        message: 'Proposal Rejected',
        open: true,
        variant: 'success'
      };
    case REJECT_PROPOSAL_FAILURE:
      return {
        message: 'Failed To Reject Proposal',
        open: true,
        variant: 'error'
      };
    case REVISION_REQUEST_SUCCESS:
      return {
        message: 'Revision Requested',
        open: true,
        variant: 'success'
      };
    case REVISION_REQUEST_FAILURE:
      return {
        message: 'Revision Request Failed',
        open: true,
        variant: 'error'
      };
    case ACCEPT_DEAL_SUCCESS:
      return {
        message: 'Deal Accepted',
        open: true,
        variant: 'success'
      };
    case ACCEPT_DEAL_FAILURE:
      return {
        message: 'Error Accepting Deal',
        open: true,
        variant: 'error'
      };
    case ESCROW_PROCESS_SUCCESS:
      return {
        message: 'Successfully Escrowed Funds',
        open: true,
        variant: 'success'
      };
    case ESCROW_PROCESS_FAILURE:
      return {
        message: 'Escrow Failed',
        open: true,
        variant: 'error'
      };
    case RELEASE_ESCROW_PROCESS_SUCCESS:
      return {
        message: 'Completed Deal!',
        open: true,
        variant: 'success'
      };
    case RELEASE_ESCROW_PROCESS_FAILURE:
      return {
        message: 'Error Completing Deal',
        open: true,
        variant: 'error'
      };
    case SUBMIT_CONTENT_SUCCESS:
      return {
        message: 'Successfully Submitted Content Info',
        open: true,
        variant: 'success'
      };
    case SUBMIT_CONTENT_FAILURE:
      return {
        message: 'Error Submitted Content Info',
        open: true,
        variant: 'error'
      };
    case PRODUCT_ADD_SUCCESS:
      return {
        message: 'Added New Product',
        open: true,
        variant: 'success'
      };
    case PRODUCT_ADD_FAILURE:
      return {
        message: 'Error Adding New Product',
        open: true,
        variant: 'error'
      };

    case OPEN_DISPUTE_SUCCESS:
      return {
        message: 'Dispute Opened',
        open: true,
        variant: 'success'
      };
    case OPEN_DISPUTE_FAILURE:
      return {
        message: 'Failed To Open Dispute',
        open: true,
        variant: 'error'
      };
    case RESET_PASSWORD_EMAIL_SEND_SUCCESS:
      return {
        message: 'Please Check Email For Reset Link',
        open: true,
        variant: 'success'
      };
    case RESET_PASSWORD_EMAIL_SEND_FAILURE:
      return {
        message: 'Failed To Send Password Reset Email',
        open: true,
        variant: 'error'
      };
    case USER_PAYPAL_INFO_SUCCESS:
      return {
        message: 'Successfully Linked Paypal Account',
        open: true,
        variant: 'success'
      };
    case USER_PAYPAL_INFO_FAILURE:
      return {
        message: 'Error Linking Paypal Account',
        open: true,
        variant: 'error'
      };
    case CONTENT_COMPLETE_SUCCESS:
      return {
        message: 'Content Complete Sent',
        open: true,
        variant: 'success'
      };
    case CONTENT_COMPLETE_FAILURE:
      return {
        message: 'Content Complete Failed',
        open: true,
        variant: 'error'
      };
    case UPDATE_COMPANY_BALANCE_FAILURE:
      return {
        message: 'Failed to Update Balance',
        open: true,
        variant: 'error'
      };
    case PAY_WITH_BALANCE_FAILURE:
      return {
        message: 'Failed to Pay With Balance',
        open: true,
        variant: 'error'
      };
    case NO_ACTIVE_CAMPAIGNS:
      return {
        message: 'No Active Campaigns',
        open: true,
        variant: 'error'
      };

    default:
      return state;
  }
};

export default notificationsReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/notificationsReducer.js